import { render, staticRenderFns } from "./ConsultarCashbackResultado.vue?vue&type=template&id=60f8d54c&scoped=true"
import script from "./ConsultarCashbackResultado.vue?vue&type=script&lang=js"
export * from "./ConsultarCashbackResultado.vue?vue&type=script&lang=js"
import style0 from "./ConsultarCashbackResultado.vue?vue&type=style&index=0&id=60f8d54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8d54c",
  null
  
)

export default component.exports